import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  AppBar,
  Toolbar,
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { LogOut } from 'react-feather';
import BusinessRoundedIcon from '@material-ui/icons/BusinessRounded';
import Divider from '@material-ui/core/Divider';
import { CORE_COLOR, GRAY, DARK_GRAY, WHITE } from '../../../theme';
import {
  chaveArmazenamentoUsuario,
  informacoesModais,
} from '../../../shared/util/Constantes';
import ModalLogout from '../../../shared/componentes/ModalLogout';
import { atualizarUsuario } from '../../login/Store';
import * as HeaderManager from '../HeaderManager';

const useStyles = makeStyles(() => ({
  gridContainer: {
    cursor: 'default',
    alignItems: 'center',
  },
  appBar: {
    position: 'fixed',
    width: '100%',
    justifyContent: 'center',
    boxShadow:
      '0px 1px 1px -2px rgba(0,0,0,0.2), 0px -1px 1px 1px rgba(0,0,0,0.05), 0px 3px 1px 3px rgba(0,0,0,0.01)',
    height: '56px',
    backgroundColor: WHITE,
    zIndex: '2',
  },
  toolbar: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    minHeight: '56px',
    padding: 0,
  },
  iconeLogout: {
    marginRight: '10px',
    marginLeft: '10px',
  },
  iesIcon: {
    marginLeft: '10px',
    marginRight: '8px',
    color: GRAY,
    height: '20px',
    width: '20px',
  },
  textoBreadcrumb: {
    color: GRAY,
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '20px',
    textTransform: 'capitalize',
  },
  textoBreadcrumbAtivo: {
    color: CORE_COLOR,
    fontWeight: 'bold',
    fontSize: '14px',
    lineHeight: '20px',
    textTransform: 'capitalize',
  },
  textoNomeCabecalho: {
    color: DARK_GRAY,
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'default',
    lineHeight: '35px',
    marginLeft: '10px'
  },
  chevronIcon: {
    marginLeft: '4px',
    marginRight: '4px',
    height: '20px',
    width: '20px',
    verticaAlign: 'center',
  },
  divider: {
    color: GRAY
  },
}));

const Header = (props) => {
  const classes = useStyles();
  const {
    user,
    clearUser,
    selectedTest,
    updateHeader,
    accuracyRate,
  } = props;

  // icone da IES > Nome da IES > Nome do Curso > Disciplina >  Nome da Prova

  let nomeUsuario = user.name;
  const nameArr = nomeUsuario.split(' ');
  if (nameArr.length > 2) {
    nomeUsuario = `${nameArr[0]} ${nameArr[nameArr.length - 1]}`;
  }

  useEffect(() => {
    let header = [];
    if (selectedTest) {
      header = [user.curso, selectedTest.DisciplineName];
    } else if (accuracyRate.disciplineName) {
      header = [user.curso, accuracyRate.disciplineName];
    } else {
      header = [user.curso];
    }
    updateHeader(header);
  }, [updateHeader, user, selectedTest, accuracyRate]);

  const [modalLogout, setModalLogout] = useState(false);

  const sair = () => {
    localStorage.removeItem(chaveArmazenamentoUsuario);
    clearUser();
  };

  const doLogout = () => {
    setModalLogout(true);
  };

  return (
    <AppBar position="absolute" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <Grid container item xs={7} className={classes.gridContainer}>
          <BusinessRoundedIcon className={classes.iesIcon} />
          <Typography noWrap className={classes.textoBreadcrumb}>
            {user.marca}
          </Typography>
        </Grid>
        <Grid container item xs={8} style={{ justifyContent: 'flex-end' }}>
          <Divider
            orientation="vertical"
            style={{ height: '35px', marginRight: '20px' }}
          />
          <Typography noWrap className={classes.textoNomeCabecalho}>
            {nomeUsuario}
          </Typography>
          <IconButton className={classes.iconeLogout} onClick={doLogout}>
            <LogOut color={GRAY} size={20} />
          </IconButton>
        </Grid>
        <ModalLogout
          modalAberto={modalLogout}
          tituloModal={informacoesModais.ModalSair.Titulo}
          textoBotaoContinuar={informacoesModais.ModalSair.TextoBotaoContinuar}
          handleBotaoContinuar={() => {
            sair();
          }}
          textoBotaoCancelar={informacoesModais.TextoBotaoCancelar}
          handleBotaoCancelar={() => {
            setModalLogout(false);
          }}
          tipo="Logout"
        />
      </Toolbar>
    </AppBar>
  );
};

const mapStateToProps = (state) => ({
  user: state.login.usuario,
  codigoIes: state.login.usuario.iesCode,
  breadcrumb: state.breadcrumb,
  selectedTest: state.listaProva.provaSelecionada,
  accuracyRate: state.accuracyRate,
});

const mapDispatchToProps = {
  clearUser: () => atualizarUsuario(null),
  updateHeader: (breadcrumb) => HeaderManager.atualizarCabecalho(breadcrumb),
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
